import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useCurrentOrg } from './useCurrentOrg';

type Options = {
  orgId?: number;
};

export function useOrgCustodians(options?: Options) {
  const { orgId } = options || {};
  const currentOrg = useCurrentOrg();
  const orgCustodians = useSelector((state: any) => state.orgs.orgCustodians);
  const idOrg = orgId || currentOrg.id;

  return useMemo(() => {
    const currentOrgCustodians = orgCustodians?.[idOrg]?.custodiansById;
    if (!currentOrgCustodians) return {};

    return currentOrgCustodians;
  }, [orgCustodians, idOrg, orgId]);
}
